import { Controller, useFormContext } from 'react-hook-form';
import { TextFieldProps } from '@mui/material/TextField';
import PhoneNumber from './PhoneNumber';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  onCountryChange?: (countryCode: string) => void;
};
export default function RHFPhoneField({ name, onCountryChange, helperText, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <PhoneNumber
          {...field}
          fullWidth
          variant="outlined"
          defaultCountry="cl"
          onlyCountries={['ht', 'cl', 'br', 'do', 'mx']}
          onCountryChange={(country: string) => {
            console.log('Selected country:', country);
            onCountryChange?.(country);
          }}
          placeholder="+509 1234-5678"
          error={!!error}
          helperText={error ? error.message : helperText}
          {...other}
        />
      )}
    />
  );
}
